import React from "react";
import { Crown, Timer, Medal, FlagTriangleRightIcon } from "lucide-react";
import { motion } from "framer-motion";

const getInitials = (name = "") =>
  name.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase();

const podiumProps = (pos) => ([
  { height: 220, baseFrom: "from-yellow-300", baseTo: "to-amber-600", ring: "ring-yellow-300/60", text: "text-yellow-200" },
  { height: 180, baseFrom: "from-gray-200",  baseTo: "to-gray-500",   ring: "ring-gray-300/50",  text: "text-gray-200"  },
  { height: 160, baseFrom: "from-orange-400",baseTo: "to-amber-800",  ring: "ring-orange-400/50",text: "text-orange-200"},
][pos]);

export const PodiumCard = ({ driver, place }) => {
  const p = podiumProps(place);
  return (
    <motion.div initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ type: "spring", stiffness: 120, delay: place * 0.15 }} className="flex flex-col items-center" style={{ height: p.height + 140 }}>
      <div className="mb-3">
        {place === 0 ? <Crown className="w-7 h-7 text-yellow-300 drop-shadow-[0_0_8px_rgba(250,204,21,0.6)]" />
         : place === 1 ? <Medal className="w-7 h-7 text-gray-300" />
         : <Medal className="w-7 h-7" style={{color: "#d37a38"}} />}
      </div>

      <div className={`relative flex flex-col items-center -mb-4 ${p.text}`}>
        <div className={`w-16 h-16 rounded-full bg-gradient-to-b ${p.baseFrom} ${p.baseTo} ring-2 ${p.ring} flex items-center justify-center font-black text-lg`}>{getInitials(driver.name)}</div>
        <div className="mt-2 text-white/90 font-semibold leading-tight text-center">{driver.name}</div>
        <div className="mt-1">
          <span className="px-2 py-0.5 text-xs uppercase tracking-wide rounded-full bg-blue-600/20 border border-blue-400/30 text-blue-300">{driver.team}</span>
        </div>
        <div className="mt-1 flex items-center gap-1 text-emerald-400 text-xs font-bold mb-1 mt-2">
          <Timer className="w-3.5 h-3.5" /> {driver.best}
        </div>
        <div className="mt-1 flex items-center gap-1  text-xs font-bold mb-1 mt-2">
          <FlagTriangleRightIcon className="w-3.5 h-3.5" /> {driver.total_race_time}
        </div>
      </div>

      <div className={`relative mt-4 w-28 rounded-t-xl overflow-hidden shadow-2xl bg-gradient-to-b ${p.baseFrom} ${p.baseTo}`} style={{ height: p.height }}>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.2),_transparent_60%)]" />
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 text-5xl font-extrabold text-black/20 select-none">{place + 1}</div>
        <div className="absolute -bottom-8 left-0 right-0 h-10 bg-black/30 blur-md" />
      </div>
    </motion.div>
  );
};
